import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useSnackbar } from 'notistack';
import { setCurrentPage } from '../../redux/entities/backlinks';
import { getBacklinks, deleteBacklinks } from '../../redux/thunks/backlinks';
import BacklinkCard from '../backlink-card/backlink-card.component';
import { BacklinksContainer } from './backlinks-list.styles';
import NewOrderModal from '../new-order-modal/new-order-modal.component';

const Backlinks = ({ manage, excludeDomain, selectedCategory }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { backlinks, currentPage, limit, totalDocs } = useSelector(
    (state) => state.entities.backlinks
  );
  const [selectedBacklinks, setSelectedBacklinks] = useState([]);
  const [showNewOrderModal, setShowNewOrderModal] = useState(false);

  const handleCheckboxChange = (_id, isChecked) => {
    if (isChecked) {
      setSelectedBacklinks([...selectedBacklinks, _id]);
    } else {
      setSelectedBacklinks(
        selectedBacklinks.filter((backlinkId) => backlinkId !== _id)
      );
    }
  };

  const handleDeleteBacklinks = (ids) => {
    const onSuccess = (message) => {
      setSelectedBacklinks((prev) => prev.filter((id) => !ids.includes(id)));
      enqueueSnackbar(message, { variant: 'success' });
    };

    const onError = (message) => {
      enqueueSnackbar(message, { variant: 'error' });
    };

    if (!ids.length) {
      return onError('לא נבחרו קישורים למחיקה');
    }

    dispatch(deleteBacklinks({ ids, onSuccess, onError }));
  };

  const handleNewOrder = () => {
    if (!excludeDomain) {
      return enqueueSnackbar('לא נבחר דומיין', { variant: 'error' });
    }

    if (!selectedBacklinks.length) {
      return enqueueSnackbar('לא נבחרו אתרים', { variant: 'error' });
    }

    setShowNewOrderModal(true);
  };

  useEffect(() => {
    dispatch(
      getBacklinks({
        page: currentPage,
        limit,
        excludeDomain,
        selectedCategory,
      })
    );
  }, [currentPage, limit, excludeDomain, selectedCategory]);

  useEffect(() => {
    dispatch(setCurrentPage(1));
  }, [excludeDomain, selectedCategory]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        flex: 1,
      }}
    >
      {selectedBacklinks.length > 0 && (
        <Card>
          <Card.Body>
            <Card.Text>אתרים שנבחרו: {selectedBacklinks.length}</Card.Text>
            <Card.Text>
              {manage ? (
                <Button
                  variant="danger"
                  onClick={() => handleDeleteBacklinks(selectedBacklinks)}
                >
                  מחק
                </Button>
              ) : (
                <Button variant="primary" onClick={handleNewOrder}>
                  המשך
                </Button>
              )}
            </Card.Text>
          </Card.Body>
        </Card>
      )}

      <BacklinksContainer
        pageStart={1}
        loadMore={() => dispatch(setCurrentPage(currentPage + 1))}
        loader={
          <div className="loader" key={0}>
            טוען...
          </div>
        }
        hasMore={currentPage * limit < totalDocs}
      >
        {backlinks.map(({ _id, domain, categories, createdAt }) => (
          <BacklinkCard
            key={_id}
            _id={_id}
            domain={domain}
            categories={categories}
            createdAt={createdAt}
            isChecked={selectedBacklinks.find(({ domain }) => domain)}
            handleCheckboxChange={handleCheckboxChange}
            handleDeleteBacklinks={handleDeleteBacklinks}
            manage={manage}
          />
        ))}
      </BacklinksContainer>

      {showNewOrderModal && <NewOrderModal
        show={showNewOrderModal}
        onClose={() => setShowNewOrderModal(false)}
        primaryDomain={excludeDomain}
        selectedBacklinks={backlinks.filter(b => selectedBacklinks.includes(b._id))}
      />}
    </div>
  );
};

export default Backlinks;
